import React, { useState, useRef, useEffect } from 'react';

interface FilterBarProps {
  searchQuery: string;
  onSearchChange: (q: string) => void;
  checkType: string;
  onCheckTypeChange: (ct: string) => void;
  selectedStatuses: string[];
  onStatusChange: (statuses: string[]) => void;
}

const ALL_STATUSES = ['Complete', 'In Work', 'In Transit', 'In Planning', 'Scheduled', 'On Hold'];
const CHECK_TYPES = ['A-Check', 'B-Check', 'C-Check', 'D-Check', 'Stand Alone', 'Unknown'];

const FilterBar: React.FC<FilterBarProps> = ({
  searchQuery,
  onSearchChange,
  checkType,
  onCheckTypeChange,
  selectedStatuses,
  onStatusChange,
}) => {
  const [statusOpen, setStatusOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setStatusOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const toggleStatus = (status: string) => {
    if (selectedStatuses.includes(status)) {
      onStatusChange(selectedStatuses.filter((s) => s !== status));
    } else {
      onStatusChange([...selectedStatuses, status]);
    }
  };

  const statusLabel =
    selectedStatuses.length === 0
      ? 'Status: None ▾'
      : selectedStatuses.length === ALL_STATUSES.length
      ? 'Status: All ▾'
      : `Status: ${selectedStatuses.length} selected ▾`;

  return (
    <section className="filter-bar">
      <input
        type="text"
        placeholder="Search by tail #, aircraft type, check type…"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <select value={checkType} onChange={(e) => onCheckTypeChange(e.target.value)}>
        <option value="">All Check Types</option>
        {CHECK_TYPES.map((ct) => (
          <option key={ct} value={ct}>
            {ct}
          </option>
        ))}
      </select>
      <div className="filter-status-dropdown" ref={dropdownRef}>
        <button
          type="button"
          className="filter-status-btn"
          onClick={() => setStatusOpen(!statusOpen)}
        >
          {statusLabel}
        </button>
        <div className={`filter-status-menu ${statusOpen ? 'open' : ''}`}>
          {ALL_STATUSES.map((s) => (
            <label key={s} className="filter-status-check">
              <input
                type="checkbox"
                checked={selectedStatuses.includes(s)}
                onChange={() => toggleStatus(s)}
              />
              {s}
            </label>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FilterBar;
